/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {CSSProperties} from "react";
import * as emotion from "emotion";

type Props = {
	show: boolean
	badge: React.JSX.Element
	top?: number
	right?: number
	customBadgeStyle?: CSSProperties
	children?: React.ReactNode
}

export class Badge
	extends React.Component<Props> {

	constructor(props: Props) {
		super(props);
	}

	render() {
		if (!this.props.show)
			return this.props.children;

		return <div style={{position: 'relative'}}>
			{this.props.children}
			<div className={emotion.css({'> div': {
					transform: 'translate(100%, -50%)'
				}})} style={{
				position: 'absolute',
				top: this.props.top,
				right: this.props.right,
				...this.props.customBadgeStyle
			}}>
				{this.props.badge}
			</div>
		</div>
	}

}
